import { Trans } from "react-i18next";
import { Icon } from "@/ui/icon/Icon";
import styles from "./CalculatorBack.module.css";

export const CalculatorBack: React.FC<{
  onClick?: () => void;
}> = ({ onClick }) => {
  return (
    <div className={styles.back} onClick={onClick}>
      <Icon className={styles.backIcon} name="arrow_left_16px" size={16} />
      <div className={styles.backText}>
        <Trans>Back To Basic Packs</Trans>
      </div>
    </div>
  );
};
